class NumberUtil {
  static formatNumber (val, digits = 0) {
    return val && !isNaN(val) ? Number(val).toLocaleString(
      undefined,
      {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }
    ) : '-'
  }
}
export default NumberUtil
